import api from './apiClient';

// ─── KULLANICILAR ────────────────────────────────────────────────────────────

export const getUsers = async () => {
  const response = await api.get('/Admin/users');
  return response.data;
};

export const createUser = async (email, fullName, reportGroupIds = [], tenantId = null) => {
  const response = await api.post('/Admin/users', { email, fullName, reportGroupIds, tenantId: tenantId ? Number(tenantId) : null });
  return response.data;
};

export const deactivateUser = async (userId) => {
  const response = await api.delete(`/Admin/users/${userId}`);
  return response.data;
};

export const toggleCanAccessTest = async (userId) => {
  const response = await api.patch(`/Admin/users/${userId}/can-access-test`);
  return response.data;
};

// Hiç giriş yapmamış kullanıcılara mail göndermeden ortak geçici şifre atar (SuperAdmin).
// Dönüş: { temporaryPassword, affectedCount, skipped }
export const assignTempPassword = async (userIds) => {
  const response = await api.post('/Admin/users/assign-temp-password', { userIds });
  return response.data;
};

// ─── RAPOR GRUPLARI ──────────────────────────────────────────────────────────

export const getAdminReportGroups = async () => {
  const response = await api.get('/Admin/report-groups');
  return response.data;
};

export const createReportGroup = async (name, description, tenantId = null, environment = 'prod', aiChatEnabled = true) => {
  const response = await api.post('/Admin/report-groups', { name, description, tenantId: tenantId ? Number(tenantId) : null, environment, aiChatEnabled });
  return response.data;
};

export const addReportToGroup = async (groupId, reportId) => {
  const response = await api.post(`/Admin/report-groups/${groupId}/reports/${reportId}`);
  return response.data;
};

export const removeReportFromGroup = async (groupId, reportId) => {
  const response = await api.delete(`/Admin/report-groups/${groupId}/reports/${reportId}`);
  return response.data;
};

// Grup içindeki raporların gösterim sırasını günceller. reportIds istenen sırada gönderilir.
export const reorderGroupReports = async (groupId, reportIds) => {
  const response = await api.put(`/Admin/report-groups/${groupId}/reports/order`, { reportIds });
  return response.data;
};

export const toggleAiChatForGroup = async (groupId) => {
  const response = await api.patch(`/Admin/report-groups/${groupId}/ai-chat`);
  return response.data;
};

// ─── RAPORLAR ────────────────────────────────────────────────────────────────

export const getAdminReports = async () => {
  const response = await api.get('/Admin/reports');
  return response.data;
};

export const createReport = async (name, powerBiReportId, description, environment, workspaceId, tenantId = null) => {
  const response = await api.post('/Admin/reports', { name, powerBiReportId, description, environment, workspaceId, tenantId: tenantId ? Number(tenantId) : null });
  return response.data;
};

export const getPowerBiReports = async (environment = 'prod', tenantId = null) => {
  const params = new URLSearchParams({ environment });
  if (tenantId) params.append('tenantId', tenantId);
  const response = await api.get(`/Admin/powerbi-reports?${params.toString()}`);
  return response.data;
};

// ─── KULLANICI - GRUP İLİŞKİSİ ───────────────────────────────────────────────

export const addUserToGroup = async (userId, groupId) => {
  const response = await api.post(`/Admin/users/${userId}/report-groups/${groupId}`);
  return response.data;
};

export const removeUserFromGroup = async (userId, groupId) => {
  const response = await api.delete(`/Admin/users/${userId}/report-groups/${groupId}`);
  return response.data;
};

// ─── AI MODELLER (REPORT CONTEXTS) ───────────────────────────────────────────

export const getReportContexts = async () => {
  const response = await api.get('/Admin/report-contexts');
  return response.data;
};

export const getReportContext = async (id) => {
  const response = await api.get(`/Admin/report-contexts/${id}`);
  return response.data;
};

export const createReportContext = async (name, dimensionDefinitions, measureDefinitions, systemPromptRules = '') => {
  const response = await api.post('/Admin/report-contexts', { name, dimensionDefinitions, measureDefinitions, systemPromptRules });
  return response.data;
};

export const updateReportContext = async (id, name, dimensionDefinitions, measureDefinitions, systemPromptRules = '') => {
  const response = await api.put(`/Admin/report-contexts/${id}`, { name, dimensionDefinitions, measureDefinitions, systemPromptRules });
  return response.data;
};

export const deleteReportContext = async (id) => {
  const response = await api.delete(`/Admin/report-contexts/${id}`);
  return response.data;
};

export const assignContextToReport = async (reportId, contextId) => {
  const response = await api.patch(`/Admin/reports/${reportId}/context/${contextId}`);
  return response.data;
};

// ─── TENANT YÖNETİMİ ─────────────────────────────────────────────────────────

export const getTenants = async () => {
  const response = await api.get('/Tenant');
  return response.data;
};

export const createTenant = async (
  name, description, powerBiWorkspaceId, powerBiTestWorkspaceId = null,
  primaryColor = null, secondaryColor = null, logoUrl = null, faviconUrl = null,
  portalTitle = null,
  textColor = null, fontBold = false, fontItalic = false, fontSize = null
) => {
  const response = await api.post('/Tenant', {
    name, description, powerBiWorkspaceId, powerBiTestWorkspaceId,
    primaryColor, secondaryColor, logoUrl, faviconUrl, portalTitle,
    textColor, fontBold, fontItalic, fontSize,
  });
  return response.data;
};
 
export const updateTenant = async (
  id, name, description, powerBiWorkspaceId, powerBiTestWorkspaceId = null,
  primaryColor = null, secondaryColor = null, logoUrl = null, faviconUrl = null,
  portalTitle = null,
  textColor = null, fontBold = false, fontItalic = false, fontSize = null
) => {
  const response = await api.put(`/Tenant/${id}`, {
    name, description, powerBiWorkspaceId, powerBiTestWorkspaceId,
    primaryColor, secondaryColor, logoUrl, faviconUrl, portalTitle,
    textColor, fontBold, fontItalic, fontSize,
  });
  return response.data;
};

export const toggleTenant = async (id) => {
  const response = await api.patch(`/Tenant/${id}/toggle`);
  return response.data;
};

export const deleteTenant = async (id) => {
  const response = await api.delete(`/Tenant/${id}`);
  return response.data;
};

// ─── MASTER DATA ─────────────────────────────────────────────────────────────
// Tüm fonksiyonlar axios api client kullanıyor.
// Token yönetimi, 401 refresh, error handling otomatik olarak apiClient.js'de.

// tenantId yoksa parametre query'ye hiç eklenmez. Doğrudan interpolasyon
// 'tenantId=null' üretir; backend'in `int?` binding'i bunu çözemeyip 400 döner.
// tenantId gönderilmediğinde sunucu zaten token'daki tenant'ı kullanır.
const tenantQuery = (tenantId) => (tenantId ? `?tenantId=${tenantId}` : '');

// Ekipler
export const getTeams = async (tenantId) => {
  const response = await api.get(`/MasterData/teams${tenantQuery(tenantId)}`);
  return response.data;
};

export const createTeam = async (teamName, tenantId) => {
  const response = await api.post('/MasterData/teams', { tenantId, teamName });
  return response.data;
};

export const updateTeam = async (id, teamName, tenantId) => {
  const response = await api.put(`/MasterData/teams/${id}`, { tenantId, teamName });
  return response.data;
};

export const deleteTeam = async (id, tenantId) => {
  const response = await api.delete(`/MasterData/teams/${id}${tenantQuery(tenantId)}`);
  return response.data;
};

// Bölgeler
export const getRegions = async (tenantId) => {
  const response = await api.get(`/MasterData/regions${tenantQuery(tenantId)}`);
  return response.data;
};

export const createRegion = async (regionName, teamId, tenantId) => {
  const response = await api.post('/MasterData/regions', { tenantId, regionName, teamId });
  return response.data;
};

export const deleteRegion = async (id, tenantId) => {
  const response = await api.delete(`/MasterData/regions/${id}${tenantQuery(tenantId)}`);
  return response.data;
};

// Temsilciler
export const getReps = async (tenantId) => {
  const response = await api.get(`/MasterData/reps${tenantQuery(tenantId)}`);
  return response.data;
};

export const createRep = async (repName, repCode, regionId, tenantId) => {
  const response = await api.post('/MasterData/reps', { tenantId, repName, repCode, regionId });
  return response.data;
};

export const updateRep = async (id, repName, repCode, regionId, tenantId) => {
  const response = await api.put(`/MasterData/reps/${id}`, { tenantId, repName, repCode, regionId });
  return response.data;
};

// Açık brick ataması olan temsilci bu uçtan silinemez (400 döner); retireRep kullanılır.
export const deleteRep = async (id, tenantId) => {
  const response = await api.delete(`/MasterData/reps/${id}${tenantQuery(tenantId)}`);
  return response.data;
};

// Temsilciyi görevden çıkarır: açık brick atamalarını endDate (ay sonu) ile kapatır,
// ertesi ayın 1'i itibarıyla aynı brick/oranlarla yeni atamaları açar ve temsilciyi siler.
// reassignments: [{ repBrickId, repId, whiteFlag, regionId }]
export const retireRep = async (id, endDate, reassignments, tenantId) => {
  const response = await api.post(`/MasterData/reps/${id}/retire`, { tenantId, endDate, reassignments });
  return response.data;
};

// Temsilcinin açık brick atamalarını başka temsilcilere devreder.
// effectiveDate ayın 1'i olmalı; atamanın kendi başlangıç ayına eşitse satır yerinde
// güncellenir (dummy atama iz bırakmaz), daha sonraki bir aysa dönem bölünür.
// assignments: [{ repBrickId, newRepId }]
export const handoverRepBricks = async (id, effectiveDate, assignments, tenantId) => {
  const response = await api.post(`/MasterData/reps/${id}/handover`, { tenantId, effectiveDate, assignments });
  return response.data;
};

// Brick Atamaları
export const getRepBricks = async (tenantId) => {
  const response = await api.get(`/MasterData/rep-bricks${tenantQuery(tenantId)}`);
  return response.data;
};

export const closeRepBrick = async (id, endDate, tenantId) => {
  const response = await api.patch(`/MasterData/rep-bricks/${id}/close`, { tenantId, endDate });
  return response.data;
};

export const deleteRepBrick = async (id, tenantId) => {
  const response = await api.delete(`/MasterData/rep-bricks/${id}${tenantQuery(tenantId)}`);
  return response.data;
};

export const createRepBrick = async (data, tenantId) => {
  const response = await api.post('/MasterData/rep-bricks', { tenantId, ...data });
  return response.data;
};

export const closeAndReassign = async (id, data, tenantId) => {
  const response = await api.post(`/MasterData/rep-bricks/${id}/close-and-reassign`, { tenantId, ...data });
  return response.data;
};

// Pazarlar
export const getMarkets = async (tenantId) => {
  const response = await api.get(`/MasterData/markets${tenantQuery(tenantId)}`);
  return response.data;
};

export const createMarket = async (marketName, teamId, tenantId,
  showInWeeklyDashboard = true, showInMonthlyDashboard = true) => {
  const response = await api.post('/MasterData/markets',
    { tenantId, marketName, teamId, showInWeeklyDashboard, showInMonthlyDashboard });
  return response.data;
};

export const updateMarket = async (id, marketName, teamId, tenantId,
  showInWeeklyDashboard = true, showInMonthlyDashboard = true) => {
  const response = await api.put(`/MasterData/markets/${id}`,
    { tenantId, marketName, teamId, showInWeeklyDashboard, showInMonthlyDashboard });
  return response.data;
};

export const deleteMarket = async (id, tenantId) => {
  const response = await api.delete(`/MasterData/markets/${id}${tenantQuery(tenantId)}`);
  return response.data;
};

// Ürünler
export const getProducts = async (tenantId) => {
  const response = await api.get(`/MasterData/products${tenantQuery(tenantId)}`);
  return response.data;
};

export const createProduct = async (product, tenantId) => {
  const response = await api.post('/MasterData/products', { tenantId, ...product });
  return response.data;
};

export const updateProduct = async (id, product, tenantId) => {
  const response = await api.put(`/MasterData/products/${id}`, { tenantId, ...product });
  return response.data;
};

export const deleteProduct = async (id, tenantId) => {
  const response = await api.delete(`/MasterData/products/${id}${tenantQuery(tenantId)}`);
  return response.data;
};

export const bulkUpdateProducts = async (products, tenantId) => {
  const response = await api.put('/MasterData/products/bulk-update', { tenantId, products });
  return response.data;
};

export const assignProductToMarket = async (productId, marketId, tenantId) => {
  const response = await api.post(`/MasterData/products/${productId}/markets/${marketId}${tenantQuery(tenantId)}`);
  return response.data;
};

export const removeProductFromMarket = async (productId, marketId, tenantId) => {
  const response = await api.delete(`/MasterData/products/${productId}/markets/${marketId}${tenantQuery(tenantId)}`);
  return response.data;
};

// Ürün Hedef Tanımları (DimProductTarget)
export const getProductTargets = async (tenantId, teamId, productSearch) => {
  const p = new URLSearchParams();
  if (tenantId)      p.append('tenantId', tenantId);
  if (teamId)        p.append('teamId', teamId);
  if (productSearch) p.append('productSearch', productSearch);
  const response = await api.get(`/MasterData/product-targets?${p}`);
  return response.data;
};

export const updateOpenPeriod = async (id, tenantId, isIncluded, multiplier) => {
  const response = await api.post(`/MasterData/product-targets/${id}/status`, {
    ...(tenantId ? { tenantId } : {}), isIncluded, multiplier,
  });
  return response.data;
};

export const closeAndReassignProductTarget = async (id, tenantId, startYear, startMonth, isIncluded, multiplier) => {
  const response = await api.post(`/MasterData/product-targets/${id}/close-and-reassign`, {
    ...(tenantId ? { tenantId } : {}), startYear, startMonth, isIncluded, multiplier,
  });
  return response.data;
};

export const deleteProductTarget = async (id, tenantId) => {
  const url = `/MasterData/product-targets/${id}${tenantQuery(tenantId)}`;
  const response = await api.delete(url);
  return response.data;
};

// Coğrafya
export const getGeography = async (tenantId) => {
  const response = await api.get(`/MasterData/geography${tenantQuery(tenantId)}`);
  return response.data;
};

// ─── BULK IMPORT ─────────────────────────────────────────────────────────────
// multipart/form-data — axios ile gönderilir.
// Content-Type header'ı axios tarafından otomatik set edilir (boundary dahil).
// Token apiClient interceptor'ı tarafından otomatik eklenir.

export const bulkImportSalesForce = async (file, tenantId) => {
  const formData = new FormData();
  if (tenantId) formData.append('tenantId', tenantId);
  formData.append('file', file);
  const response = await api.post('/MasterData/salesforce/bulk-import', formData);
  return response.data;
};

export const bulkImportProductsMarkets = async (file, tenantId) => {
  const formData = new FormData();
  if (tenantId) formData.append('tenantId', tenantId);
  formData.append('file', file);
  const response = await api.post('/MasterData/products-markets/bulk-import', formData);
  return response.data;
};

// ─── TENANT LABEL CONFIG ──────────────────────────────────────────────────────

export const getTenantLabels = async (tenantId, screenKey) => {
  const response = await api.get(`/Tenant/${tenantId}/labels/${screenKey}`);
  return response.data;
};

export const upsertTenantLabel = async (tenantId, screenKey, columnKey, label) => {
  const response = await api.put(`/Tenant/${tenantId}/labels/${screenKey}/${columnKey}`, { label });
  return response.data;
};

export const refreshReportDataset = async (reportId) => {
  const response = await api.post(`/Admin/reports/${reportId}/refresh`);
  return response.data;
};

// ─── TENANT UYGULAMA REGISTRY ─────────────────────────────────────────────────

// Etkin tenant için katalog × etkinlik (AdminPage sekme görünürlüğü).
export const getEnabledApplications = async (tenantId) => {
  const p = new URLSearchParams();
  if (tenantId) p.append('tenantId', tenantId);
  const response = await api.get(`/Applications?${p}`);
  return response.data;
};

export const getTenantApplications = async (tenantId) => {
  const response = await api.get(`/Tenant/${tenantId}/applications`);
  return response.data;
};

export const setTenantApplication = async (tenantId, appKey, isEnabled, configJson = null) => {
  const response = await api.put(`/Tenant/${tenantId}/applications/${appKey}`, { isEnabled, configJson });
  return response.data;
};

// ─── HEDEF DAĞILIMI ───────────────────────────────────────────────────────────

export const getTargetDefinitions = async (tenantId, { yearQuarter, teamId, status } = {}) => {
  const p = new URLSearchParams();
  if (tenantId)    p.append('tenantId', tenantId);
  if (yearQuarter) p.append('yearQuarter', yearQuarter);
  if (teamId)      p.append('teamId', teamId);
  if (status)      p.append('status', status);
  const response = await api.get(`/TargetDistribution/definitions?${p}`);
  return response.data;
};

export const getTargetDefinition = async (id, tenantId) => {
  const p = new URLSearchParams();
  if (tenantId) p.append('tenantId', tenantId);
  const response = await api.get(`/TargetDistribution/definitions/${id}?${p}`);
  return response.data;
};

export const getTargetFormOptions = async (tenantId) => {
  const p = new URLSearchParams();
  if (tenantId) p.append('tenantId', tenantId);
  const response = await api.get(`/TargetDistribution/form-options?${p}`);
  return response.data;
};

export const getTargetResult = async (id, tenantId) => {
  const p = new URLSearchParams();
  if (tenantId) p.append('tenantId', tenantId);
  const response = await api.get(`/TargetDistribution/definitions/${id}/result?${p}`);
  return response.data;
};

export const createTargetScenario = async (tenantId, payload) => {
  const response = await api.post('/TargetDistribution/definitions', {
    ...(tenantId ? { tenantId } : {}), ...payload,
  });
  return response.data;
};

export const updateTargetScenario = async (id, tenantId, payload) => {
  const response = await api.put(`/TargetDistribution/definitions/${id}`, {
    ...(tenantId ? { tenantId } : {}), ...payload,
  });
  return response.data;
};

export const deleteTargetScenario = async (id, tenantId) => {
  const url = `/TargetDistribution/definitions/${id}${tenantQuery(tenantId)}`;
  const response = await api.delete(url);
  return response.data;
};

// Sonucu Excel (.xlsx) olarak indirir — tam axios response döner (blob + headers).
export const exportTargetResult = async (id, tenantId) => {
  const p = new URLSearchParams();
  if (tenantId) p.append('tenantId', tenantId);
  return api.get(`/TargetDistribution/definitions/${id}/result/export?${p}`, { responseType: 'blob' });
};

export const distributeTarget = async (id, tenantId) => {
  const response = await api.post(`/TargetDistribution/definitions/${id}/distribute`, tenantId ? { tenantId } : {});
  return response.data;
};

export const getTargetStatus = async (id, tenantId) => {
  const p = new URLSearchParams();
  if (tenantId) p.append('tenantId', tenantId);
  const response = await api.get(`/TargetDistribution/definitions/${id}/status?${p}`);
  return response.data;
};

export const publishTarget = async (id, tenantId) => {
  const response = await api.post(`/TargetDistribution/definitions/${id}/publish`, tenantId ? { tenantId } : {});
  return response.data;
};

export const unpublishTarget = async (id, tenantId) => {
  const response = await api.post(`/TargetDistribution/definitions/${id}/unpublish`, tenantId ? { tenantId } : {});
  return response.data;
};

export const getRefreshStatus = async (reportId) => {
  const response = await api.get(`/Admin/reports/${reportId}/refresh-status`);
  return response.data;
};